<template>
  <div id="wv_daily_insights">
    <div class="header">
      <div class="box flex-mid">
        <img
          class="icon-card mr-16 cursor-pointer"
          @click="goBackDay()"
          :src="$utils('icons', 'navigate_before_white_32px')"
          alt=""
        />
        <el-date-picker
          v-model="dateInput"
          type="date"
          format="ddd, MMMM d, yyyy"
          value-format="yyyy-MM-dd"
          placeholder="Pick a day"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <img
          @click="goNextDay()"
          class="icon-card ml-16 cursor-pointer"
          :src="$utils('icons', 'navigate_after_white_32px')"
          alt=""
        />
      </div>
    </div>
    <template v-if="inforDailyData && inforDailyData.preview">
      <div v-html="inforDailyData.preview"></div>
    </template>
    <div v-else class="center fc-A0A0A0 fs-24 mt-32">
      <div v-if="!dateInput" style="padding-top: 80px">
        <div class="fs-16 fw-700 fc-000000 opa-04">
          Preview a report by selecting a date <br />
          from the above menu
        </div>
      </div>
      <div v-else-if="loadingDailyReportStatus" style="padding-top: 80px">
        <i class="el-icon-loading"></i>
        <div class="fs-16">Loading...</div>
      </div>
      <div
        style="padding-top: 80px"
        v-else-if="!loadingDailyReportStatus && !inforDailyData.preview"
      >
        <div class="fs-16">
          Unable to preview this report due to unavailability of sufficient data
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import subDays from 'date-fns/sub_days';
export default {
  name: "daily-insights",

  data() {
    return {
      firstTimeloading: true,
      email:'',
      themeMode: "light",
      dateInput: "",
      pickerOptions: {
        disabledDate(date) {
          return new Date() < date || date < new Date("2021-08-31") || new Date(date).getDay() == 0 || new Date(date).getDay() == 1;
        },
      },
    };
  },
  watch: {
    dateInput() {
      this.getDataReport()
    },
    inforDailyData() {
      if(this.inforDailyData && this.inforDailyData.date){
        document.title = "Happily - Daily Insights for Managers - "+ format(new Date(this.inforDailyData.date),"MMM d")
      }
    }
  },
  computed: {
    backgroundColor() {
      switch (this.themeMode) {
        case "light":
          return "light";
        case "dark":
          return "dark";
        default:
          return "light";
      }
    },
    inforDailyData() {
      return this.$store.getters["report/inforDailyData"];
    },
    loadingDailyReportStatus() {
      return this.$store.getters["report/loadingDailyReportStatus"];
    },
  },
  mounted() {
    if(this.$route.params.id){
        let bytes = CryptoJS.AES.decrypt(
        this.$route.params.id,
          "HappilyDaily"
        );
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        if (originalText) {
          let codeSplit = originalText.split("||");
          this.email = codeSplit[0].replace(/\|\|/g, '.');
          this.dateInput = codeSplit[1];
          
          if(this.dateInput){
            document.title = "Happily - Daily Insights for Managers - "+ format(new Date(format(addDays(this.dateInput,-1),"YYYY-MM-DD")),"MMM D")
          }
          //this.getDataReport();
        }
      }
    
  },
  methods: {
    getDataReport(){

      if(this.email && this.dateInput){
        this.$store.dispatch("report/getDataPreview", {
          user: this.email,
          date:this.dateInput,
          type: "report_daily_boss",
          loading: "Daily",
        }).then(()=>{
          this.firstTimeloading = false;
        });
      }
    },
    goBackDay() {
      // console.log("goBackDay", this.dateInput) // TODO : goBackDay function.
        if (this.dateInput) {
          let beforeThisDay = this.dateInput
          if(format(addDays(beforeThisDay,-1),"YYYY-MM-DD") > format(new Date("2021-08-31"),"YYYY-MM-DD")){
            do{
              beforeThisDay = format(addDays(beforeThisDay,-1),"YYYY-MM-DD")
            }
            while(new Date(beforeThisDay).getDay() == 0 || new Date(beforeThisDay).getDay() == 1)
            this.dateInput = beforeThisDay;
          }
        } else {
          this.dateInput = format(new Date(),"YYYY-MM-DD")
        }
    },
    goNextDay() {
      // console.log("goNextDay", this.dateInput) // TODO : goNextDay function.
      if (this.dateInput) {
        let nextDay = this.dateInput
        if(format(addDays(nextDay,1),"YYYY-MM-DD") <= format(new Date(),"YYYY-MM-DD")){
          do{
            nextDay = format(addDays(nextDay,1),"YYYY-MM-DD")
          }
          while(new Date(nextDay).getDay() == 0 || new Date(nextDay).getDay() == 1)
          this.dateInput = nextDay;
        }
      } else {
        this.dateInput = format(new Date(),"YYYY-MM-DD")
      }
    },
  }
};
</script>

<style lang="scss" scoped>
// .light, .dark {
//   min-height: 400px;
// }
// .light {
//   background-color: #fff;
// }
// .dark {
//   background-color: #242424;
// }
.header {
  height: calc(80px - 32px);
  background: #6d27bf;
  padding: 16px;
  .box {
    color: #fff;
  }
}
</style>

<style lang="scss">
#wv_daily_insights {
  input,
  .el-input--prefix .el-input__inner,
  .el-input__inner {
    border: 1px solid rgba($color: #000000, $alpha: 0.2);
    background-color: rgba($color: #000000, $alpha: 0.2);
    color: #fff;
    height: 48px;
  }
}
</style>